import React from 'react';
import styled from 'styled-components';
import {
    useBreakpoint,
    Text,
    Box,
    MaestroComponent,
    IconProps,
} from '@landr/maestro';
import { ComponentHeader } from 'components/Header/Header';

/* @maestro-no-token */
const IconWrapper = styled.div`
    g,
    path {
        stroke-width: 1;
    }
`;

const UspCard = ({
    title,
    description,
    icon,
}: {
    title: string;
    description: string;
    icon: MaestroComponent<IconProps, Record<string, any>>;
}) => {
    const isMobile = useBreakpoint('md');
    const iconComponent = React.createElement(icon, {
        color: 'primary.500',
        size: isMobile ? 'md' : 'xl',
    });

    return (
        <Box>
            <IconWrapper>{iconComponent}</IconWrapper>
            <ComponentHeader>{title}</ComponentHeader>
            <Text contrast="low" size="md">
                {description}
            </Text>
        </Box>
    );
};

export default UspCard;
